import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `ACCT-DELETE` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/profile/edit` (ADR-0009 bất biến 5). 🔴 US-AIV2-tourguide-0008 (@UC0362): trước là `/profile` —
 * màn đó KHÔNG có nút «Xoá tài khoản» (nút nằm ở `/profile/edit`, khảo sát 05/10) ⇒ hợp đồng nội dung màn đỏ.
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 12 — cụm tài khoản: xoá tài khoản (GDPR). CLAUDE.md §3.8: purge = ẨN DANH, KHÔNG xoá sổ, Σ CASH TRƯỚC = Σ CASH SAU).
 */
export const ACCT_DELETE = {
  id: "ACCT-DELETE",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Xoá tài khoản của bạn khỏi Goppy.",
    examples: [
      "xoá tài khoản của tôi",
      "xoa tai khoan cua toi",
      "tôi muốn xoá tài khoản",
      "toi muon xoa tai khoan",
      "huỷ tài khoản",
      "xoá tk",
      // ——— 0105: thêm cho đủ 40 ———
      "huy tai khoan",
      "xoa tk",
      "tôi không dùng app nữa, xoá tài khoản giúp",
      "toi khong dung app nua xoa tai khoan giup",
      "xoá tài khoản kiểu gì?",
      "xoa tai khoan kieu gi",
      "cho tôi đóng tài khoản",
      "cho toi dong tai khoan",
      "muốn xoá hẳn tài khoản Goppy",
      "muon xoa han tai khoan goppy",
      "xoá hồ sơ và tài khoản của tôi",
      "xoa ho so va tai khoan cua toi",
      "làm sao để xoá tài khoản vĩnh viễn",
      "lam sao de xoa tai khoan vinh vien",
      "tôi muốn dừng dùng, xoá tài khoản luôn",
      "toi muon dung dung xoa tai khoan luon",
      "xoá sạch dữ liệu và tài khoản Goppy",
      "xoa sach du lieu va tai khoan goppy",
      "xoá acc",
      "xoa acc",
      "tôi muốn đóng tài khoản Goppy của mình",
      "toi muon dong tai khoan goppy cua minh",
      "xoá tài khoản thì dữ liệu có mất không?",
      "xoa tai khoan thi du lieu co mat khong",
      "tôi không xài nữa, cho xoá tài khoản",
      "toi khong xai nua cho xoa tai khoan",
      "huỷ hẳn tài khoản của tôi nhé",
      "huy han tai khoan cua toi nhe",
      "xoá tài khoản ngay",
      "xoa tai khoan ngay",
      "cho mình xoá tài khoản với",
      "cho minh xoa tai khoan voi",
      "tôi cần xoá tài khoản cá nhân",
      "toi can xoa tai khoan ca nhan",
      "chấm dứt tài khoản của tôi",
      "cham dut tai khoan cua toi",
    ],
  },
  screen: "/profile/edit",
  screenShows: "account_delete",
  endpoints: [
    "DELETE /me",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở trang tài khoản nhé. Xoá tài khoản là ẨN DANH bạn khỏi mọi nhóm — sổ thu chi của nhóm vẫn nguyên con số, chỉ không còn tên bạn. Việc này không lấy lại được nên phải bấm tận tay.",
  },
  journey: { after: ["ACCT-PROFILE"] },
  help: { title: "Xoá tài khoản", tryNow: "xoá tài khoản của tôi" },
} satisfies AiCapabilityPage;
